import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-align_top_fill",
  "use": "icon-align_top_fill-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-align_top_fill\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n<path d=\"M6,6H18V7.5L6,7.44Zm4,13H8V12H6L9,9l3,3H10Zm6,0H14V12H12l3-3,3,3H16Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol